import React, { useEffect, useRef } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../@style/ara_hakkimizda.css';
import magazaImage from '../assets/images/magaza.jpg';

const AraHakkimizda = () => {
  const { isDarkMode } = useTheme();
  const textRef = useRef(null);
  const imageRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const container = containerRef.current;
      
      if (container) {
        const rect = container.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Görünür alana girdiğinde animasyonu başlat
        if (rect.top < windowHeight * 0.7) {
          textRef.current.style.transform = 'translateX(0)';
          imageRef.current.style.transform = 'translateX(0)';
          textRef.current.style.opacity = '1';
          imageRef.current.style.opacity = '1';
        } else {
          // Görünür alandan çıktığında kaybolma
          textRef.current.style.transform = 'translateX(-100px)';
          imageRef.current.style.transform = 'translateX(100px)';
          textRef.current.style.opacity = '0';
          imageRef.current.style.opacity = '0';
        }
      }
    };

    // Sayfa yüklendiğinde ilk animasyonu başlat
    setTimeout(() => {
      handleScroll();
    }, 100);

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`ara-hakkimizda-container ${isDarkMode ? 'dark-mode' : ''}`} ref={containerRef}>
      <div className="ara-hakkimizda-content">
        <div className="text-section" ref={textRef}>
          <h1 className="main-title">Hakkımızda</h1>
          <h2 className="subtitle">Tarihçe</h2>
          
          <div className="content-text">
            <p>
              ENG Kıymetli Madenler, kıymetli madenler sektöründe üç nesilden gelen bilgi birikimi, tecrübe ve ticari disiplinin bir yansıması olarak faaliyet göstermektedir. Köklü geçmişinden aldığı güçle, altın ve gümüş ticaretinde güven, süreklilik ve kalite odaklı bir yaklaşımı benimsemiştir.
            </p>
            
            <p>
              İstanbul ve Diyarbakır merkezli operasyonlarıyla, başta Güneydoğu Anadolu Bölgesi olmak üzere Türkiye genelinde kuyumculuk sektörüne ürün tedariği sağlayan ENG Kıymetli Madenler, güçlü tedarik zinciri ve gelişmiş lojistik altyapısı sayesinde ürünlerini geniş bir coğrafyaya hızlı ve güvenli şekilde ulaştırmaktadır.
            </p>
            
            <p>
              Gram altın, külçe altın, külçe gümüş ve sarrafiye ürün gruplarında, uluslararası standartlara uygun ve sertifikalı ürün portföyü ile faaliyet gösteren şirket; sektörde güvenilirliği, şeffaflığı ve rekabetçi fiyat politikasıyla öne çıkmaktadır.
            </p>
            
            <p>
              Üç kuşaktan aktarılan ticari anlayışı modern iş yönetimi ile birleştiren ENG Kıymetli Madenler, kıymetli madenler ticaretinde güçlü konumunu koruyarak sürdürülebilir büyümesini kararlılıkla devam ettirmektedir.
            </p>
          </div>
        </div>
        
        <div className="image-section" ref={imageRef}>
          <div className="image-container">
            <img src={magazaImage} alt="ENG Kıymetli Madenler Mağaza" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AraHakkimizda;
